import React, { useEffect, useRef, useState } from 'react';
import { usePortfolioView } from '../../context/PortfolioViewContext';

export const ShowRealizedGainsToggle: React.FC = () => {
  const { showRealizedGains, setShowRealizedGains } = usePortfolioView();
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = () => {
    tooltipTimeoutRef.current = setTimeout(() => {
      setShowTooltip(true);
    }, 500);
  };

  const handleMouseLeave = () => {
    if (tooltipTimeoutRef.current) {
      clearTimeout(tooltipTimeoutRef.current);
      tooltipTimeoutRef.current = null;
    }
    setShowTooltip(false);
  };

  useEffect(() => {
    return () => {
      if (tooltipTimeoutRef.current) {
        clearTimeout(tooltipTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div
      className="relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <label className="flex items-center gap-1.5 cursor-pointer">
        <span className="text-right text-[10px] font-medium leading-[10px] text-gray-500">
          <span className="block whitespace-nowrap">show realized</span>
          <span className="block">gains</span>
        </span>
        <input
          type="checkbox"
          checked={showRealizedGains}
          onChange={(event) => setShowRealizedGains(event.target.checked)}
          aria-label="show realized gains"
          className="w-4 h-4 text-gray-400 bg-gray-50 border-gray-200 rounded focus:ring-gray-300 focus:ring-2"
        />
      </label>

      {showTooltip && (
        <div className="absolute bottom-full right-0 mb-2 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap z-10">
          show realized gains
          <div className="absolute top-full right-2 -mt-1">
            <div className="border-4 border-transparent border-t-gray-800"></div>
          </div>
        </div>
      )}
    </div>
  );
};
